module.exports = __webpack_public_path__ + "static/media/radar_loader.74f388bb.svg";